// removed by extract-text-webpack-plugin
module.exports = {"log-pane":"log-pane__log-pane___4PesL","warning-pane":"log-pane__warning-pane___NtOZY","error-pane":"log-pane__error-pane___9VrKM","close":"log-pane__close___1Q42q"};